import { COLORS } from '~/data/ui/colors';
import theme from '~/theme';

export const btnTextStyle = {
  display: 'none',
  [theme.breakpoints.up('md')]: {
    display: 'flex',
    paddingRight: '15px',
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '150%',
  },
};

export const shareBtnStyle = {
  '&:hover': {
    backgroundColor: COLORS.primary.light2,
  },
  borderRadius: '20px',
  height: '40px',
  [theme.breakpoints.up('md')]: {
    paddingInline: '16px',
  },
  [theme.breakpoints.down('md')]: {
    height: '40px',
  },
  '& span': {
    padding: '0',
    margin: '0',
  },
};

export const openShareBtnStyle = {
  backgroundColor: COLORS.primary.light2,
};
